import { sortOptionsISelect } from '../helpers/sortISelect';
import { EducationalAttainment } from '../model/enumerations/educational-attainment.model';
import { ISelect } from '../model/iSelect';

export const educationalAttainmentEnum = (): Array<ISelect> => {
  const educationalAttainment: Array<ISelect> = [
    {
      label: "Secundario",
      value: EducationalAttainment.HIGHSCHOOL,
    },
    {
      label: "Postgrado",
      value: EducationalAttainment.POSTGRADUATE,
    },
    {
      label: "Terciario",
      value: EducationalAttainment.TERTIARY,
    },
    {
      label: "Universitario",
      value: EducationalAttainment.UNIVERSITY,
    },
  ];
  return sortOptionsISelect(educationalAttainment);
};
